<template>
  <div>
    <div
      class="tw-rounded-md tw-rounded-bl-none tw-bg-white tw-p-3 tw-text-sm tw-text-neutral-600 tw-shadow-sm"
    >
      <p>{{ review.comment }}</p>
    </div>
    <div class="tw-mt-4 tw-flex tw-justify-between">
      <div class="tw-flex tw-items-center tw-space-x-2">
        <Avatar
          :src="review.authorAvatarUrl"
          :alt="`${review.authorName}'s avatar`"
          size="md"
        />
        <div>
          <div class="tw-heading-6">{{ review.authorName }}</div>
          <div class="tw--mt-px tw-text-xs tw-text-neutral-500">
            {{ review.createdDate }}
          </div>
        </div>
      </div>
      <PinReviewButton
        v-if="
          hasObjectPermissions(
            $page.props.mentor,
            OBJECT_PERMISSIONS.MENTORS.OWNER,
          )
        "
        :id="review.id"
        :is-pinned="
          hasObjectPermissions(review, OBJECT_PERMISSIONS.REVIEWS.FAVORITED)
        "
        :path="review.favoriteReviewPath"
      />
    </div>
  </div>
</template>

<script setup>
import Avatar from '@/shared/components/avatar/Avatar.vue'
import PinReviewButton from './PinReviewButton.vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import { OBJECT_PERMISSIONS } from '@/shared/data/permissionSystem.js'

defineProps({
  review: {
    type: Object,
    required: true,
  },
})

const { hasObjectPermissions } = usePermissionSystem()
</script>
